import React from 'react';
import { FilterButton, FilterHideColumns } from "./button-filter";
import { FilterGlobalSearch } from "./global-search";
import { ExportButton } from "../export";
import '@isyc-react/design/main';
import "./table-global-filter.style.scss";
export const TableGlobalFilter = props => {
  const {
    instance
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "table-global-filter"
  }, /*#__PURE__*/React.createElement(FilterGlobalSearch, {
    instance: instance
  }), /*#__PURE__*/React.createElement("div", {
    className: "me-2"
  }, /*#__PURE__*/React.createElement(ExportButton, {
    instance: instance
  })), /*#__PURE__*/React.createElement(FilterButton, null, /*#__PURE__*/React.createElement(FilterHideColumns, {
    instance: instance
  })));
};